import React from 'react';

/**
 * Direct-answer block for AI overviews / featured snippets.
 * Renders a concise, quotable answer directly under the H1.
 * The wrapper class `direct-answer` is referenced by Speakable schema.
 */
const DirectAnswer = ({ question, answer, bullets = [], className = '' }) => (
  <div
    className={`direct-answer bg-white border-2 border-[#01A9B4]/30 rounded-2xl p-6 md:p-8 shadow-md text-left ${className}`}
    data-testid="direct-answer"
  >
    <p className="text-xs font-semibold uppercase tracking-widest text-[#006A71] mb-2">Quick answer</p>
    {question && <p className="text-lg md:text-xl font-bold text-rabbit mb-3">{question}</p>}
    <p className="text-base md:text-lg text-chocolate-malt leading-relaxed">{answer}</p>
    {bullets.length > 0 && (
      <ul className="mt-4 grid sm:grid-cols-2 gap-2 text-sm text-chocolate-malt">
        {bullets.map((b) => (
          <li key={b} className="flex gap-2"><span className="text-[#01A9B4] font-bold" aria-hidden="true">✓</span><span>{b}</span></li>
        ))}
      </ul>
    )}
  </div>
);

export default DirectAnswer;
